import { isString, toNumber } from 'lodash';
import { conformToMask, createNumberMask } from './inputMasks';
export const mask = createNumberMask({
    allowDecimal: true,
    integerLimit: 13,
    allowLeadingZeroes: true,
});
export const noDecimalMask = createNumberMask({
    allowDecimal: false,
    integerLimit: 13,
});
export const normalize = string => {
    if (!string) {
        return string;
    }
    let padded;
    if (string.includes('.')) {
        padded = /\d\./.test(string)
            ? `${string}00`
            : `${string.replace('.', '0.')}00`;
    }
    else {
        padded = `${string}.00`;
    }
    return conformToMask(padded, mask, { guide: false }).conformedValue;
};
export const normalizeNoDecimal = string => {
    if (!string) {
        return string;
    }
    let padded = null;
    if (string.includes('.')) {
        padded = string.replace(/[^0-9.]/g, '');
        padded = Math.round(padded).toString();
    }
    return conformToMask(padded || string, noDecimalMask, { guide: false })
        .conformedValue;
};
export const stringify = apiValue => {
    if (Number.isFinite(apiValue)) {
        return normalize(apiValue.toString());
    }
    else {
        return '';
    }
};
export const parse = uiValue => {
    if (isString(uiValue) && uiValue.length) {
        const numberCharacters = uiValue.match(/[\d.]/g) || [];
        return toNumber(numberCharacters.join(''));
    }
};
//# sourceMappingURL=currency.js.map